import {ColumnRecord} from '@ui/NewTable/types';
import {
    getOperationStatusLabel,
    getUserStatusLabel,
    operationStatusColors,
    userStatusColors,
} from './constants';
import {OperationStatus, UserStatus} from './types';
import {Typography} from '@mui/material';

export const formateAccountsColumns = (columns: ColumnRecord) => {
    const newColumns = {...columns};

    if (newColumns['status']) {
        newColumns['status'].getFilterLabel = (option: string) =>
            getUserStatusLabel(option as UserStatus);

        newColumns['status'].customDisplayFormat = (_rowId: any, value: string) => (
            <Typography
                sx={{fontSize: '14px'}}
                color={userStatusColors[value as UserStatus]}
            >
                {getUserStatusLabel(value as UserStatus)}
            </Typography>
        );
    }

    if (newColumns['operationStatus']) {
        newColumns['operationStatus'].customDisplayFormat = (_rowId: any, value: string) =>
            value ? (
                <Typography
                    sx={{fontSize: '14px'}}
                    color={operationStatusColors[value as OperationStatus]}
                >
                    {getOperationStatusLabel(value as OperationStatus)}
                </Typography>
            ) : (
                ''
            );
    }

    return newColumns;
};
